import { ChannelRegistrantCounts } from '@/types/registration.types';
import { Get } from '../helpers';

export default function GetChannelRegistrantCounts({
  channel,
  projectUuid,
  signal,
}: {
  channel: number;
  projectUuid: string;
  signal?: AbortSignal;
}) {
  return Get<{ data: ChannelRegistrantCounts }>({
    url: `/v4/admin/attendees/${channel}/${projectUuid}/channel-counts`,
    signal,
  });
}
